import {Injectable, Type} from '@angular/core';
import {TextInputComponent} from './input-type/text-input/text-input.component';
import {FileUploadComponent} from './input-type/file-upload/file-upload.component';
import {InputComponent} from './input-type/input.component';
import {ListInputComponent} from './input-type/list-input/list-input.component';
import {AutocompleteInputComponent} from './input-type/autocomplete-input/autocomplete-input.component';
import {
    DialogConfigInputOptionType
} from 'botato-botengine-browser/botato/botato-botengine/source/Core/DialogConfig/DialogConfig.js';

@Injectable()
export class BotatoChatInputResolverService {

    public inputMappings = new Map<string, Type<InputComponent<DialogConfigInputOptionType>>>();

    constructor() {
        this.inputMappings.set(TextInputComponent.TYPE, TextInputComponent);
        this.inputMappings.set(FileUploadComponent.TYPE, FileUploadComponent);
        this.inputMappings.set(ListInputComponent.TYPE, ListInputComponent);
        this.inputMappings.set(AutocompleteInputComponent.TYPE, AutocompleteInputComponent);
    }

    public resolve(inputType: string): Type<InputComponent<DialogConfigInputOptionType>> {
        const inputTypeComponent = this.inputMappings.get(inputType);
        if (inputTypeComponent === undefined) {
            throw new Error(`No InputComponent available for type ${inputType}`);
        }

        return inputTypeComponent;
    }
}
